import { gql, useQuery } from "@apollo/client";
import { Dayjs } from "dayjs";
import { BookedClassRoomDto } from "./types.ts";

export const GetBookedClassRoomsQuery = gql`
  query getBookedClassRooms($fromDate: String!, $toDate: String!) {
    getBookedClassRooms(fromDate: $fromDate, toDate: $toDate) {
      classRoomId
      startUtc
      endUtc
      teacherId
      classRoomTimezone
      userGroupId
      is1on1
    }
  }
`;

export type GetBookedClassRoomsQueryResult = {
  getBookedClassRooms: BookedClassRoomDto[];
};

export function useBookedClassRooms({
  fromDate,
  toDate,
}: {
  fromDate: Dayjs;
  toDate: Dayjs;
}) {
  const { data, loading } = useQuery<GetBookedClassRoomsQueryResult>(
    GetBookedClassRoomsQuery,
    {
      fetchPolicy: "cache-and-network",
      variables: {
        fromDate: fromDate.toISOString(),
        toDate: toDate.toISOString(),
      },
    },
  );

  return {
    classRooms: data?.getBookedClassRooms ?? [],
    loading,
  };
}
